// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"cc614e24","337":"723eb643","766":"cac262e3","970":"8a5021fe"}[chunkId] + ".chunk.js";
};